import { Trans, t } from '@lingui/macro';
import { Field, Input, Select2 } from '@economic/taco';
import { useCurrentUser, useCurrentAgreement } from '@economic/react-app';
import ExternalLink from '~/app/shared/components/ExternalLink';
import type { CompanyResponse } from '~/payment-cards-feature';

interface Props {
    companyData: CompanyResponse;
    currencyCode: string;
    trackEvent: (event: string) => void;
    children: string | JSX.Element;
}

export default function ConfirmInformation({ companyData, currencyCode, trackEvent, children }: Props) {
    const user = useCurrentUser();
    const agreement = useCurrentAgreement();

    const selectData = [
        {
            data: currencyCode,
            text: currencyCode,
            value: currencyCode,
        },
    ];

    return (
        <>
            <div className="mb-5">{children}</div>
            <div className="mb-2">
                <h2 className="text-center">
                    <Trans>Confirm information</Trans>
                </h2>
                <p className="mb-4">
                    <Trans>Confirm the information to be forwarded to your agreement in Rackbeat.</Trans>
                </p>
                <div className="mb-2">
                    <div className="grid grid-cols-2 gap-5">
                        <div>
                            <Field>
                                <Trans>Company</Trans>
                                <Input aria-label={t`Company`} value={companyData?.model.name} readOnly />
                            </Field>
                            <Field>
                                <Trans>CVR</Trans>
                                <Input aria-label={t`CVR`} value={agreement.cvr} readOnly />
                            </Field>
                            <Field>
                                <Trans>e-conomic agreement no.</Trans>
                                <Input aria-label={t`Agreement`} value={agreement.number} readOnly />
                            </Field>
                            <Field>
                                <Trans>Base currency</Trans>
                                <Select2 value={currencyCode} readOnly>
                                    {selectData.map(item => (
                                        <Select2.Option key={item.data} value={item.value}>
                                            {item.text}
                                        </Select2.Option>
                                    ))}
                                </Select2>
                            </Field>
                        </div>
                        <div>
                            <Field>
                                <Trans>Superuser</Trans>
                                <Input aria-label={t`Super user`} value={user.firstName} readOnly />
                            </Field>
                            <Field>
                                <Trans>Superuser email</Trans>
                                <Input aria-label={t`Super user e-mail`} value={companyData?.model.email} readOnly />
                            </Field>
                            <Field>
                                <Trans>Telephone</Trans>
                                <Input aria-label={t`Phone number`} value={companyData?.model.phone} readOnly />
                            </Field>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mb-4">
                <Trans>
                    Do you need to change your master data? Close this window, update your information in{' '}
                    <ExternalLink
                        href="https://secure.e-conomic.com/settings/company/master-information"
                        openNewTab={false}
                        onClick={() => trackEvent('update-info-link.click')}>
                        Settings
                    </ExternalLink>
                    , and add Warehouse from Rackbeat again.
                </Trans>
            </div>
        </>
    );
}
